var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.applyClasses(( _obj = {
        'cl-linear-progress': true
    }, _obj[("cl-linear-progress--color-" + _vm.color)] = true, _obj[("cl-linear-progress--variant-" + _vm.variant)] = true, _obj ), _vm.classes.root),attrs:{"role":"progress-bar","aria-valuenow":Math.round(_vm.value)}},[_c('div',{class:_vm.applyClasses(( _obj$1 = {
        'cl-linear-progress__bar': true
      }, _obj$1[("cl-linear-progress__bar-one--color-" + _vm.color)] = true, _obj$1['cl-linear-progress__bar-one'] =  true, _obj$1 ), _vm.classes.bar1),style:({
            transform: ("scaleX(" + (_vm.value / 100) + ")")
        })}),(_vm.variant !== 'determinate')?_c('div',{staticClass:"cl-linear-progress__bar cl-linear-progress__bar-two"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }